import { mount, type MountInstance } from '../utils/components';
import Toast from './toast.vue';
import type { ToastOptions } from './toast';

const defaultOptions = {
  visible: false,
  icon: 'text',
  duration: 2000,
  showDotLine: false,
  autoHide: true,
};

let toastInstance: MountInstance | null = null;
let timer: any;

function showToast(options: ToastOptions) {
  const opts = Object.assign({}, defaultOptions, options, { visible: true });

  if (timer) {
    hideToast();
    clearTimeout(timer);
    timer = 0;
  }

  toastInstance = mount(Toast, opts);

  if (opts.autoHide) {
    timer = setTimeout(() => {
      hideToast();
    }, opts.duration || defaultOptions.duration);
  }
}

const hideToast = () => {
  if (toastInstance) {
    toastInstance.unmount();
    toastInstance = null;
  }
};

export { showToast, hideToast };
